var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticClass:"line",attrs:{"fill":"currentColor","d":"M4 26a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v20zm12.5-1v-8h-2v-3h2c0-5.16.22-5.5 6.5-5.5v3c-3.31 0-3 .19-3 2.5h3v3h-3v8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }